import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import { ClientPortalConfigStore } from '~/components/ClientExperience/stores/client-portal-config.store';
import { S3ApiAdapter } from '~/components/ClientExperience/services/adapters/s3-api.adapter';
import { ICXCompanyConfiguration } from '~/types/cx-types/cx-company-configuration.types';
import {
    CXEnvironments,
    ICXEnvironment
} from '~/types/cx-types/cx-environment.types';
import { CXNoAuthApiService } from '~/components/ClientExperience/services/cx-no-auth-api.service';
import { IConfiguration } from '~/types/server.types';
import { gonPath } from '~/utils/ts-routes.utils';
import { CXCompanyConfigurationService } from '~/services/cx-services/cx-company-configuration.service';

export class ConfigCXAdapter extends BaseHttpAdapter {
    clientPortalConfigStore: ClientPortalConfigStore;
    noAuthApiService: CXNoAuthApiService;
    cxCompanyConfigurationService: CXCompanyConfigurationService;

    constructor({
        clientPortalConfigStore,
        noAuthApiService,
        cxCompanyConfigurationService,
        s3ApiAdapter
    }: {
        clientPortalConfigStore: ClientPortalConfigStore;
        noAuthApiService: CXNoAuthApiService;
        cxCompanyConfigurationService: CXCompanyConfigurationService;
        s3ApiAdapter: S3ApiAdapter;
    }) {
        super(s3ApiAdapter);

        this.clientPortalConfigStore = clientPortalConfigStore;
        this.noAuthApiService = noAuthApiService;
        this.cxCompanyConfigurationService = cxCompanyConfigurationService;
    }

    async fetchClientPortalConfiguration(
        clientPortalEnvironment: ICXEnvironment
    ): Promise<ICXCompanyConfiguration> {
        const { isPreview } = this.clientPortalConfigStore;

        if (isPreview) {
            return null;
        }

        return this.cxCompanyConfigurationService.fetchCompanyConfiguration(
            clientPortalEnvironment
        );
    }

    async fetchPlacementGenericConfig<IGenericConfig>() {
        const { env, isPreview } = this.clientPortalConfigStore;

        if (isPreview) {
            return null;
        }

        const prefix =
            env.environment === CXEnvironments.Staging
                ? 'staging_assets'
                : 'assets_users_production';

        return this.apiService.apiRequest<IGenericConfig>({
            url: `${prefix}/websiteplacements/placement_generic_config.js?xhr=1`,
            isJsonp: true
        });
    }

    async fetchGon(): Promise<IConfiguration> {
        return this.noAuthApiService.apiRequest({
            url: gonPath()
        });
    }
}
